import type { ComponentPropsWithoutRef, FC } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';
import { safeBound } from '@wwe-portal/ui/lib/math';

import style from './progress-bar.module.css';

interface ProgressBar extends ComponentPropsWithoutRef<'div'> {
  value: number;
  maxValue: number;
  hideValue?: boolean;
  barHeight?: number;
  isShowMax?: boolean;
  valueClassname?: string;
  progressClassname?: string;
  animationDuration?: number;
  color?: string;
}
export const ProgressBar: FC<ProgressBar> = ({
  value,
  barHeight = 20,
  maxValue,
  className,
  hideValue,
  isShowMax = false,
  valueClassname,
  color = '',
  progressClassname,
  animationDuration,
  ...divProps
}) => {
  const percent = safeBound((value * 100) / maxValue, 0, 100);

  const getShowValue = () => {
    if (value < maxValue) {
      return `${value}/${maxValue}`;
    }
    if (isShowMax) {
      return `MAX`;
    }
    return `${value}/${maxValue}`;
  };

  return (
    <div
      {...divProps}
      className={cn(
        'bg-text700 relative overflow-hidden rounded-[15px]',
        className
      )}
    >
      <div
        className={cn(
          `relative w-full overflow-hidden rounded-[15px] transition-all duration-1000 ease-linear`,
          style.progress,
          progressClassname
        )}
        style={{
          height: barHeight,
          width: `${percent}%`,
          animationDuration:
            animationDuration != null ? `${animationDuration}ms` : undefined,
          transitionDuration:
            animationDuration != null ? `${animationDuration}ms` : undefined,
          background:
            color ||
            (percent < 100
              ? 'linear-gradient(90deg, #ff4500, #ffa800, #fb0)'
              : 'linear-gradient(90deg, #0db184 0%, #10e2a8 100.53%)'),
        }}
      />
      {!hideValue && (
        <div
          className={cn(
            'absolute inset-y-0 right-3 flex items-center text-sm',
            valueClassname
          )}
        >
          {getShowValue()}
        </div>
      )}
    </div>
  );
};
